export default "__VITE_ASSET__BcdTALSC__"